import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {NgbModule, NgbNavModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {QuillModule} from 'ngx-quill';
import {ImageCropperModule} from 'ngx-image-cropper';

import {CoreDirectivesModule} from '../../../@core/directives/directives';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';

import {BlogRoutingModule} from './blog-routing.module';
import {BlogListComponent} from './components/blog-list/blog-list.component';
import {BlogFormComponent} from './components/blog-form/blog-form.component';
import {BlogCategoriesComponent} from './components/blog-categories/blog-categories.component';
import {BlogTagsComponent} from './components/blog-tags/blog-tags.component';

@NgModule({
    declarations: [
        BlogListComponent,
        BlogFormComponent,
        BlogCategoriesComponent,
        BlogTagsComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlogRoutingModule,
        NgbModule,
        NgbNavModule,
        NgbPaginationModule,
        CoreCommonModule,
        CoreDirectivesModule,
        ContentHeaderModule,
        CardSnippetModule,
        TranslateModule,
        QuillModule,
        ImageCropperModule
    ]
})
export class BlogModule {
}
